import * as Icons from './icons';

export const ADJUSTABLE_DOOR_STORAGE = {
  icon: Icons.AdjustableShelvesIcon,
  labels: ['Adjustable Door Storage'],
  alt: 'Adjustable Door Storage'
};

export const ADJUSTABLE_SHELVES = {
  icon: Icons.AdjustableShelvesIcon,
  labels: ['Adjustable Shelves'],
  alt: 'Adjustable Shelves'
};

export const ICE_MAKER_REMOVABLE_BASKET = {
  icon: Icons.IceCubesIcon,
  labels: ['Ice Maker w/Removable Basket'],
  alt: 'Ice Maker w/Removable Basket'
};

export const FREEZER_TEMP_CONTROL = {
  icon: Icons.ThermometerIcon,
  labels: ['Freezer Temp Control'],
  alt: 'Freezer Temp Control'
};

export const DOOR_ALARM = {
  icon: Icons.BellIcon,
  labels: ['Door Alarm'],
  alt: 'Door Alarm'
};

export const PRINTPROOF_STAINLESS_STEEL = {
  icon: Icons.FingerprintIcon,
  labels: ['PrintProof Stainless Steel'],
  alt: 'PrintProof Stainless Steel'
};

export const CRUSHED_CUBED_ICE = {
  icon: Icons.IceCubesIcon,
  labels: ['Crushed & Cubed Ice'],
  alt: 'Crushed & Cubed Ice'
};

export const SMART_HOME_ENABLED = {
  icon: Icons.WifiIcon,
  labels: ['Smart Home Enabled'],
  alt: 'Smart Home Enabled'
};

export const FINGERPRINT_RESISTANT = {
  icon: Icons.FingerprintIcon,
  labels: ['Fingerprint Resistant'],
  alt: 'Fingerprint Resistant'
};

export const EXTERNAL_ICE_DISPENSER = {
  icon: Icons.IceCubesIcon,
  labels: ['External Ice Dispenser'],
  alt: 'External Ice Dispenser'
};

export const EXTERNAL_WATER_DISPENSER = {
  icon: Icons.WaterDropIcon,
  labels: ['External Water Dispenser'],
  alt: 'External Water Dispenser'
};

export const INTERNAL_WATER_DISPENSER = {
  icon: Icons.WaterDropIcon,
  labels: ['Internal Water Dispenser'],
  alt: 'Internal Water Dispenser'
};

export const INTERNAL_ICE_DISPENSER = {
  icon: Icons.IceCubesIcon,
  labels: ['Internal Ice Dispenser'],
  alt: 'Internal Ice Dispenser'
};

export const SMUDGE_PROOF_STAINLESS_STEEL = {
  icon: Icons.FingerprintIcon,
  labels: ['Smudge-Proof Stainless Steel'],
  alt: 'Smudge-Proof Stainless Steel'
};

export const getIconLabel = (labels = [], iconSetIndex = 0) => (
  labels[iconSetIndex] ?? labels[0] ?? ''
);
